/* ==========================================================================
   TSS Mondkalender — month switching.

   The page has to know the date by itself. The QR code in the printed
   calendar goes to press in December and has to lead to the right month all
   year, so nobody can be expected to come back and change anything.

   All twelve months are in the document. Liquid cannot read a query
   parameter, so a URL per month is not available — and putting the months in
   the markup has a second benefit: with no JavaScript the page still shows
   the month the server picked.
   ========================================================================== */
(function () {
  var roots = document.querySelectorAll('[data-mond-kalender]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    var tablist = root.querySelector('[data-mond-months]');
    var tabs = [].slice.call(root.querySelectorAll('[data-mond-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-mond-panel]'));
    if (!tablist || tabs.length < 2) return;

    function panelFor(month) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-mond-panel') === month) return panels[i];
      }
      return null;
    }

    /* Only the selected tab is reachable with Tab; the rest are reached with
       the arrow keys from inside. That is the tab pattern, and it is why the
       eleven months you are not reading do not cost eleven presses to get
       past. */
    function select(month, focusTab) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-mond-tab') === month;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focusTab) tab.focus();
      });

      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-mond-panel') === month;
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });

      reveal(month);
    }

    /* The strip is wider than a phone, so the month in use can sit off the
       edge. Only the strip's own scrollLeft is touched — never
       scrollIntoView, which is allowed to move the page's vertical scroll as
       well and would drag the reader somewhere they did not ask to go. */
    function reveal(month, instant) {
      if (tablist.scrollWidth <= tablist.clientWidth + 1) return;
      var tab = null;
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].getAttribute('data-mond-tab') === month) { tab = tabs[i]; break; }
      }
      if (!tab) return;

      var strip = tablist.getBoundingClientRect();
      var rect = tab.getBoundingClientRect();
      var delta = (rect.left - strip.left) - (strip.width - rect.width) / 2;
      if (Math.abs(delta) < 2) return;

      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      tablist.scrollBy({ left: delta, behavior: (instant || still) ? 'auto' : 'smooth' });
    }

    /* The strip opens where the month is, not at January.

       Twelve months are wider than a phone, so on a page loaded in September
       the selected month sits off the right edge: the strip shows JAN to JUN,
       none of them marked, and the page looks like nothing is selected at all.

       Without animation, because this is not a movement the reader made — it
       is where the strip was supposed to be all along. Run again on `load`,
       since the web fonts change how wide the months are and the scroll
       position that was right before the swap is a few pixels out after it. */
    function showActive(instant) {
      var current = root.querySelector('[data-mond-tab][aria-selected="true"]');
      if (current) reveal(current.getAttribute('data-mond-tab'), instant !== false);
    }

    requestAnimationFrame(function () { showActive(true); });
    window.addEventListener('load', function () { showActive(true); });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab.getAttribute('data-mond-tab'), false);
      });
    });

    /* The "next month is coming" line carries a button that switches to it.
       Wired here rather than in the strip, because the button lives inside a
       panel and is replaced along with it — looked up fresh on every click so
       it keeps working after a switch. */
    root.addEventListener('click', function (event) {
      var go = event.target.closest && event.target.closest('[data-mond-goto]');
      if (!go || !root.contains(go)) return;
      var month = go.getAttribute('data-mond-goto');
      if (panelFor(month)) select(month, false);
    });

    tablist.addEventListener('keydown', function (event) {
      var index = tabs.indexOf(document.activeElement);
      if (index === -1) return;

      var next = null;
      switch (event.key) {
        case 'ArrowRight': next = (index + 1) % tabs.length; break;
        case 'ArrowLeft':  next = (index - 1 + tabs.length) % tabs.length; break;
        case 'Home':       next = 0; break;
        case 'End':        next = tabs.length - 1; break;
        default: return;
      }

      event.preventDefault();
      select(tabs[next].getAttribute('data-mond-tab'), true);
    });

    /* The server already chose a month, from the shop's own clock. This is the
       second opinion, and it exists for one reason: a cached page served after
       midnight on the first of the month would otherwise show the month that
       has just ended.

       It reads the visitor's own date rather than the shop's, which is the
       one that matches what they would call today.

       Skipped entirely when a month is being previewed — the whole point of
       the override is to look at January in December, and correcting it would
       undo that. */
    if (root.getAttribute('data-mond-preview') === 'true') return;

    var now = String(new Date().getMonth() + 1);
    var current = root.querySelector('[aria-selected="true"]');
    if (!current || current.getAttribute('data-mond-tab') === now) return;
    if (panelFor(now)) select(now, false);
  });
})();
